// Store di traduzione automatica dei contenuti DINAMICI.
// - Raccoglie le stringhe italiane richieste dai componenti <T>/useAutoTranslate
// - Le invia in batch a POST /api/i18n/translate (con debounce)
// - Memorizza in RAM + localStorage (cache permanente lato client)
// - Notifica i componenti iscritti quando arrivano nuove traduzioni
import { api } from '@/services/client';

const memory = new Map();       // `${lang}:${text}` -> tradotto
const pending = new Map();      // lang -> Set(text)
const subscribers = new Set();  // callback di re-render
const hydrated = new Set();     // lingue già caricate da localStorage
let timer = null;

const LS_PREFIX = 'sila_tr_';
const lsKey = (lang) => `${LS_PREFIX}${lang}`;

function loadLS(lang) {
  try { return JSON.parse(localStorage.getItem(lsKey(lang)) || '{}'); } catch { return {}; }
}
function saveLS(lang, obj) {
  try { localStorage.setItem(lsKey(lang), JSON.stringify(obj)); } catch { /* quota */ }
}
function hydrate(lang) {
  if (hydrated.has(lang)) return;
  const obj = loadLS(lang);
  Object.entries(obj).forEach(([k, v]) => memory.set(`${lang}:${k}`, v));
  hydrated.add(lang);
}

export function getCached(lang, text) {
  if (lang === 'it') return text;
  hydrate(lang);
  return memory.get(`${lang}:${text}`);
}

export function requestTranslation(lang, text) {
  if (lang === 'it' || !text || typeof text !== 'string') return;
  hydrate(lang);
  if (memory.has(`${lang}:${text}`)) return;
  if (!pending.has(lang)) pending.set(lang, new Set());
  pending.get(lang).add(text);
  schedule();
}

function schedule() {
  if (timer) return;
  timer = setTimeout(flush, 150);
}

async function flush() {
  timer = null;
  const langs = Array.from(pending.keys());
  for (const lang of langs) {
    const set = pending.get(lang);
    const texts = Array.from(set).slice(0, 120);
    texts.forEach((t) => set.delete(t));
    if (texts.length === 0) continue;
    try {
      const { data } = await api.post('/i18n/translate', { target: lang, texts });
      const map = (data && data.translations) || {};
      const lsObj = loadLS(lang);
      Object.entries(map).forEach(([src, tr]) => {
        memory.set(`${lang}:${src}`, tr);
        lsObj[src] = tr;
      });
      saveLS(lang, lsObj);
      notify();
    } catch { /* silenzioso: resta l'originale */ }
  }
  if (Array.from(pending.values()).some((s) => s.size)) schedule();
}

function notify() { subscribers.forEach((cb) => { try { cb(); } catch { /* noop */ } }); }
export function subscribe(cb) { subscribers.add(cb); return () => subscribers.delete(cb); }
